import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from '../../colors-ts';
import {formControlColorStates} from '../shared/form-control-color-states';

export const checkboxOverrides: Components<Theme>['MuiCheckbox'] = {
    defaultProps: {
        color: 'info',
    },
    styleOverrides: {
        root: {
            ...formControlColorStates('MuiCheckbox', {
                Default: {
                    '&.Mui-checked, &.MuiCheckbox-indeterminate': {
                        color: COLORS.info.main,
                    },
                },
            }),
        },
    },
};
